
import { toRefs,ref } from 'vue'
import {useRouter} from 'vue-router'
export default {
  props: {
    title: {
        type: String,
        defaulr: 'I’m looking for…'
    }
  },
  setup(props: any){
      const router = useRouter()
      const { title } = toRefs(props)
      const searchs = ref('https://image.kilimall.com/kenya/new_wap/userCenter/ic_search@2x.png'.webpFilters()
)
      const search_fn = ()=>{
          router.push('/search-middle')
      }
      return {
        title,
        searchs,
        search_fn
      }
  }
}
